import {decodeTopojsonFeatures} from '../resources/utils';

export const addHotspotsLayer = (view) => {
    let opacity = 0.7;
    window.fireMap.addSource(`pts`, {
      type: 'geojson',
      data: window.fireData.hotspots,
    });
    window.fireMap.addLayer({
      id: `pts-layer`,
      type: 'circle',
      source: `pts`,
      paint: {
        'circle-radius': {
          base: 0,
          stops: [[2, 0], [6, 0], [8, 2], [12, 4]],
        },
        'circle-color': [
          'match',
          ['get', 'source'],
          'NOAA', '#e31a1c',
          'DESCARTES', '#e31a1c',
          /* other */ '#ccc',
        ],
        'circle-opacity': opacity,
      }
    }, 'water-point-label');

}
